export default "__VITE_ASSET__56bb3c6c__"